import { InstructionType } from 'app/src/engine/Instruction';
import * as store from 'store';

const LOCAL_STORAGE_KEYS = {
	SAVED_PROGRAMS: 'SAVED_PROGRAMS',
	HIGHEST_COMPLETED_LEVEL: 'HIGHEST_COMPLETED_LEVEL',
	EDITOR_LEVEL_DATA: 'EDITOR_LEVEL_DATA',
};

export default class LocalStorageManager {
	public static sharedInstance = new LocalStorageManager();

	public getSavedProgram(level: string): InstructionType[] | null {
		const savedLevels = store.get(LOCAL_STORAGE_KEYS.SAVED_PROGRAMS);

		if (!savedLevels) {
			return null;
		}

		return savedLevels[level] || null;
	}

	public saveProgram(level: string, program: InstructionType[]): void {
		const savedLevels = store.get(LOCAL_STORAGE_KEYS.SAVED_PROGRAMS) || {};
		store.set(LOCAL_STORAGE_KEYS.SAVED_PROGRAMS, { ...savedLevels, [level]: program });
	}

	public getHighestCompletedLevel(): string | null {
		return store.get(LOCAL_STORAGE_KEYS.HIGHEST_COMPLETED_LEVEL) || null;
	}

	public setHighestCompletedLevel(level: string | null): void {
		store.set(LOCAL_STORAGE_KEYS.HIGHEST_COMPLETED_LEVEL, level);
	}

	public getEditorLevelData(): string | null {
		return store.get(LOCAL_STORAGE_KEYS.EDITOR_LEVEL_DATA) || null;
	}

	public saveEditorLevelData(levelData: string): void {
		store.set(LOCAL_STORAGE_KEYS.EDITOR_LEVEL_DATA, levelData);
	}

	public resetUnlockedLevels(): void {
		store.remove(LOCAL_STORAGE_KEYS.HIGHEST_COMPLETED_LEVEL);
	}
}
